/* FurBuddy favourites — the single owner of wishlist state. */
(function () {
  var KEY = 'fb_liked';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.6-7-9.3A4 4 0 0 1 12 8a4 4 0 0 1 7 2.7C19 15.4 12 20 12 20z"/></svg>';
  var liked = [];
  try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); if (v && v.length) liked = v.map(String); } catch (e) {}

  function save() { try { localStorage.setItem(KEY, JSON.stringify(liked)); } catch (e) {} }
  function has(id) { return liked.indexOf(String(id)) > -1; }

  function count() {
    document.querySelectorAll('.fb-wish-count').forEach(function (el) {
      el.textContent = liked.length;
      el.hidden = liked.length === 0;
      el.classList.remove('pop');
      void el.offsetWidth;
      if (liked.length) el.classList.add('pop');
    });
  }

  function paint() {
    document.querySelectorAll('[data-wish-id]').forEach(function (b) {
      var on = has(b.dataset.wishId);
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    count();
  }

  function toast(msg) {
    var t = document.querySelector('.fb-toast');
    if (!t) return;
    t.innerHTML = msg;
    t.classList.add('show', 'on');
    clearTimeout(t._w);
    t._w = setTimeout(function () { t.classList.remove('show', 'on'); }, 2600);
  }

  function toggle(id, btn) {
    id = String(id);
    var i = liked.indexOf(id);
    var added = i === -1;
    if (added) liked.push(id); else liked.splice(i, 1);
    save();
    paint();
    if (btn) {
      btn.classList.remove('pop');
      void btn.offsetWidth;
      btn.classList.add('pop');
    }
    toast(added ? 'Saved to your favourites · <a href="/pages/favourites">View</a>' : 'Removed from favourites');
    return added;
  }

  function bind(root) {
    (root || document).querySelectorAll('.fb-heart,.fbp-card-heart,.fbw-heart').forEach(function (btn) {
      if (btn.dataset.wishBound) return;
      var id = btn.dataset.id || btn.dataset.wishId;
      if (!id) return;
      btn.dataset.wishId = id;
      btn.dataset.wishBound = '1';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        toggle(id, btn);
      });
    });
  }

  function productHeart() {
    var stage = document.getElementById('fbdStage');
    if (!stage || stage.querySelector('.fbw-heart')) return;
    var id = stage.dataset.productId || document.body.dataset.productId;
    if (!id) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fbw-heart';
    b.dataset.id = id;
    b.setAttribute('aria-label', 'Save to favourites');
    b.innerHTML = HEART;
    stage.appendChild(b);
  }

  function renderPage() {
    var wrap = document.getElementById('fbwGrid');
    if (!wrap) return;
    var all = [];
    try { all = JSON.parse(document.getElementById('fbwData').textContent); } catch (e) {}
    var mine = all.filter(function (p) { return has(p.id); });
    var empty = document.getElementById('fbwEmpty');
    var head = document.getElementById('fbwCount');
    var clear = document.getElementById('fbwClear');

    if (head) head.textContent = mine.length === 1 ? '1 saved item' : mine.length + ' saved items';
    if (empty) empty.hidden = mine.length > 0;
    if (clear) clear.hidden = mine.length === 0;
    wrap.hidden = mine.length === 0;
    wrap.innerHTML = '';

    mine.forEach(function (p, i) {
      var el = document.createElement('article');
      el.className = 'fbw-card';
      el.style.animationDelay = (i * 0.05) + 's';
      el.innerHTML =
        '<a class="fbw-media" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" width="600" height="600" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="fbw-heart" data-id="' + p.id + '" aria-label="Remove from favourites">' + HEART + '</button>' +
        '<a href="' + p.url + '"><h3>' + p.title + '</h3></a>' +
        '<span class="fbw-price">' + p.price + '</span>' +
        (p.variant ? '<button type="button" class="fbw-add" data-variant="' + p.variant + '">Add to bag</button>' : '');
      wrap.appendChild(el);
    });

    wrap.querySelectorAll('.fbw-heart').forEach(function (btn) {
      btn.dataset.wishBound = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('.fbw-card');
        toggle(btn.dataset.id, null);
        if (card) { card.classList.add('going'); setTimeout(renderPage, 380); }
        else renderPage();
      });
    });

    wrap.querySelectorAll('.fbw-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.textContent;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: btn.dataset.variant, quantity: 1 }] })
        }).then(function () {
          btn.textContent = 'Added ✓';
          btn.classList.add('done');
          toast('Added to your bag · <a href="/cart">View bag</a>');
          setTimeout(function () { btn.textContent = label; btn.classList.remove('done'); }, 2000);
        }).catch(function () { btn.textContent = label; });
      });
    });
  }

  function start() {
    productHeart();
    bind();
    paint();
    renderPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    try { liked = JSON.parse(e.newValue || '[]').map(String); } catch (err) { liked = []; }
    paint();
    renderPage();
  });
})();
